export default "__VITE_ASSET__CYr_uOLD__"